module.exports = __webpack_public_path__ + "static/img/Outstanding.fccbc552.png";